import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[580px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20with%20abstract%20geometric%20patterns%20and%20warm%20subtle%20lighting%20in%20deep%20charcoal%20and%20burgundy%20tones%2C%20modern%20minimalist%20design%2C%20atmospheric%20gradient%2C%20clean%20composition%2C%20no%20text%2C%20no%20people&width=1600&height=700&seq=hero-bg-01&orientation=landscape"
        alt="黑料吃瓜网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-xs text-primary-200 font-medium whitespace-nowrap">24小时不打烊</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-6 leading-tight">
            黑料吃瓜网
          </h1>

          <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-8 leading-relaxed">
            聚焦91黑料吃瓜网、黑料吃瓜在线观看等热门搜索词。提供黑料吃瓜视频、黑料吃瓜爆料与最新网红塌房实录，点开即看独家吃瓜资源。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="#latest"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href="#hot"
              className="px-8 py-3 bg-white/10 text-white font-medium text-sm rounded-full hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              热门爆料
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}